import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { AlertStatus } from 'helpers/enums';

export type Notification = {
  id: string;
  status: AlertStatus;
  message: string;
  description?: string;
};

const adapter = createEntityAdapter<Notification>();

const slice = createSlice({
  name: 'notifications',
  initialState: adapter.getInitialState(),
  reducers: {
    addOne: adapter.addOne,
    removeOne: adapter.removeOne,
  },
});

export const { addOne, removeOne } = slice.actions;

export const selectors = adapter.getSelectors<RootState>((state) => state.notifications);

export default slice.reducer;
